module.exports = __webpack_public_path__ + "static/media/full_set.23e901ab.jpg";